import styled from "styled-components";
import { setCursor } from "../variables/cursors";
import { BREAKPOINTS } from "../variables/breakpoints";
import { setFlex } from "../variables/utils";

export const AppWrapper = styled.div`
  height: ${props => (props.$isWebGLAvailable ? "100vh" : "auto")};
  width: 100%;
  overflow: hidden;
  position: relative;
  &:hover {
    ${setCursor("grab")};
  }
`;

export const Scene = styled.div`
  width: 100%;
  height: auto;
  &:hover {
    ${setCursor("grab")};
  }
  &.grabbing {
    ${setCursor("grabbing")};
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    pointer-events: none;
  }
`;

export const ImageContainer = styled.div`
  ${setFlex({ justify: "center", align: "center" })};
  position: relative;
  display: flex;
  padding-bottom: 1rem;
`;

export const Image = styled.img`
  width: auto;
  max-width: 100%;
  display: block;
`;
